<template>
  <div>
    <el-button
      size="small"
      type="primary"
      :disabled="disabledBatch"
      @click="showBatchForm"
      >记录原因</el-button
    >
    <el-radio-group class="ml10" v-model="queryForm.recordType" size="small" @change="search">
      <el-radio-button :label="3">全部</el-radio-button>
      <el-radio-button :label="2">已记录</el-radio-button>
      <el-radio-button :label="1">未记录</el-radio-button>
    </el-radio-group>
    <el-checkbox-group class="ml10 inline-block" v-if="query" size="small" v-model="queryForm.breakCodes" @change="search">>
      <el-checkbox-button label="02">确认取消</el-checkbox-button>
      <el-checkbox-button label="01">取消</el-checkbox-button>
      <el-checkbox-button label="03">延迟发货</el-checkbox-button>
      <el-checkbox-button label="04">错发</el-checkbox-button>
      <el-checkbox-button label="05">漏发</el-checkbox-button>
      <el-checkbox-button label="06">瑕疵</el-checkbox-button>
    </el-checkbox-group>
    <el-input
      class="ml10"
      v-if="query"
      style="width: 200px"
      v-model="queryForm.orderLineNum"
      size="small"
      placeholder="请输入order_line_num"
    ></el-input>
    <el-button size="small" v-if="query" type="primary" @click="search"
      >搜索</el-button
    >
    <el-table v-loading="loading" :data="tableData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        prop="orderLineNum"
        width="130"
        label="order_line_num"
      ></el-table-column>
      <el-table-column prop="orderCreatedAt">
        <template slot="header" slot-scope="scope">
          创建时间<br />(UTC +8)
        </template>
        <template slot-scope="scope">
          {{ scope.row.orderCreatedAt && scope.row.orderCreatedAt.split(' ')[0] }}<br>
          {{ scope.row.orderCreatedAt && scope.row.orderCreatedAt.split(' ')[1] }}
        </template>
      </el-table-column>
      <el-table-column prop="orderCreatedAt" v-if="query">
        <template slot="header" slot-scope="scope">
          判责时间<br />(UTC +8)
        </template>
        <template slot-scope="scope">
          {{ scope.row.judgmentTime && scope.row.judgmentTime.split(' ')[0] }}
          <br>
          {{ scope.row.judgmentTime && scope.row.judgmentTime.split(' ')[1] }}
        </template>
      </el-table-column>
      <el-table-column prop="orderCancelledAt" v-if="!query && breakType === 0">
        <template slot="header" slot-scope="scope">
          取消时间<br />(UTC +8)
        </template>
        <template slot-scope="scope">
          {{ scope.row.orderCancelledAt && scope.row.orderCancelledAt.split(' ')[0] }}<br>
          {{ scope.row.orderCancelledAt && scope.row.orderCancelledAt.split(' ')[1] }}
        </template>
      </el-table-column>
      <el-table-column prop="orderShippedAt" v-if="!query && breakType === 1">
        <template slot="header" slot-scope="scope">
          发货时间<br />(UTC +8)
        </template>
        <template slot-scope="scope">
          {{ scope.row.orderShippedAt && scope.row.orderShippedAt.split(' ')[0] }}<br>
          {{ scope.row.orderShippedAt && scope.row.orderShippedAt.split(' ')[1] }}
        </template>
      </el-table-column>
      <el-table-column
        prop="errorResponsibleConfirmedAt"
        v-if="!query && breakType === 2"
      >
        <template slot="header" slot-scope="scope">
          错漏判责时间<br />(UTC +8)
        </template>
        <template slot-scope="scope">
          {{ scope.row.errorResponsibleConfirmedAt && scope.row.errorResponsibleConfirmedAt.split(' ')[0] }}<br>
          {{ scope.row.errorResponsibleConfirmedAt && scope.row.errorResponsibleConfirmedAt.split(' ')[1] }}
        </template>
      </el-table-column>
      <el-table-column prop="flawResponsibleConfirmedAt" v-if="!query && breakType === 3">
        <template slot="header" slot-scope="scope">
          瑕疵判责时间<br />(UTC +8)
        </template>
        <template slot-scope="scope">
          {{ scope.row.flawResponsibleConfirmedAt && scope.row.flawResponsibleConfirmedAt.split(' ')[0] }}<br>
          {{ scope.row.flawResponsibleConfirmedAt && scope.row.flawResponsibleConfirmedAt.split(' ')[1] }}
        </template>
      </el-table-column>
      <el-table-column prop="breakType" label="违规类型"></el-table-column>
      <el-table-column prop="breakDay" label="时长/级别">
        <template slot="header" slot-scope="{ column, $index }">
          <span>时长/级别</span>
          <el-popover
            placement="top-start"
            title="时长/级别 :"
            width="250"
            trigger="hover"
            content="对应不同违规类型的判责结果如: 取消订单为取消时长,延迟发货为延迟时长,错漏瑕订单为瑕疵级别"
          >
            <i slot="reference" class="el-icon-warning-outline"></i>
          </el-popover>
        </template>
        <template slot-scope="scope">
          {{ scope.row.breakDay }}
        </template>
      </el-table-column>
      <el-table-column label="违约原因">
        <template slot-scope="scope">
          {{ scope.row.defaultReasonName }}
          <el-popover
            v-if="scope.row.defaultRemark"
            placement="top-start"
            width="200"
            trigger="hover"
            :content="scope.row.defaultRemark"
          >
            <el-button slot="reference" type="text">备注</el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="豁免原因">
        <template slot-scope="scope">
          {{ scope.row.exemptionReasonName }}
          <el-popover
            v-if="scope.row.exemptionRemark"
            placement="top-start"
            width="200"
            trigger="hover"
            :content="scope.row.exemptionRemark"
          >
            <el-button slot="reference" type="text">备注</el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="豁免结果">
        <template slot-scope="scope">
          <div class="tag success" v-if="scope.row.auditStatus === 2">
            豁免通过
          </div>
          <div class="tag" v-if="scope.row.auditStatus === 3">已驳回</div>
        </template>
      </el-table-column>
      <el-table-column label="审核状态">
        <template slot-scope="scope">
          <div class="tag primary" v-if="scope.row.auditStatus === 1">
            待审批
          </div>
          <div
            class="tag success"
            v-if="scope.row.auditStatus === 2 || scope.row.auditStatus === 3"
          >
            审批完成
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="scope.row.auditStatus === 1 && scope.row.causeRecordId"
            @click="showForm(scope.row, 1)"
            >编辑修改</el-button
          >
          <el-button
            type="text"
            v-if="!scope.row.causeRecordId"
            @click="showForm(scope.row, 2)"
            >记录原因</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      v-if="query"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog
      title="违约原因"
      append-to-body
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-form ref="form" :model="form" label-width="80px" :close-on-click-modal="false">
        <el-form-item label="订单号">{{ showOrderLineNum }}</el-form-item>
        <el-form-item label="违约类型">{{ showBreakType }}</el-form-item>
        <el-form-item label="违约原因" prop="defaultReasonId" :rules="[{ required: true, message: '请选择违约原因' }]">
          <el-cascader
            style="width: 100%"
            v-model="reasonValue"
            :options="reasonList"
            @change="handleChangeReason"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="备注说明">
          <el-input type="textarea" v-model="form.defaultRemark" maxlength="200"></el-input>
        </el-form-item>
        <el-form-item label="是否豁免">
          <el-switch v-model="form.exemptionFlag"></el-switch>
        </el-form-item>
        <el-form-item label="豁免原因" prop="exemptionReasonId" v-if="form.exemptionFlag" :rules="[{ required: true, message: '请选择豁免原因' }]">
          <el-cascader
            style="width: 100%"
            v-model="exemptionReasonValue"
            :options="exemptionReasonList"
            @change="handleChangeExemptionReason"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="豁免备注" v-if="form.exemptionFlag">
          <el-input type="textarea" v-model="form.exemptionRemark" maxlength="200"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { formatDateTime, changeParams } from "@/utils/functions";
import {
  getPerformanceOrderList,
  getDefaultReasonList,
  getExemptionReasonList,
  editExemption,
  batchSaveExemption
} from "./api";
export default {
  props: {
    breakType: Number,
    query: Boolean,
    vendorId: [Number, String],
    startAt: Number,
    endAt: Number,
    breakCodes: Array,
    breakDay: String,
  },
  data() {
    return {
      loading: false,
      selection: [],
      queryForm: {
        recordType: 3,
        breakCodes: ['01', '02', '03', '04', '05', '06'],
        pageNo: 1,
        pageSize: this.query ? 10 : 1000,
        orderLineNum: '',
      },
      tableData: [],
      total: 0,
      dialogVisible: false,
      showOrderLineNum: "",
      showBreakType: "",
      form: {
        causeRecordId: null,
        defaultReasonId: [],
        defaultRemark: '',
        exemptionFlag: false,
        exemptionReasonId: [],
        exemptionRemark: null,
        itemReqs: [],
        orderBreakTypeId: null,
        orderLineNum: null,
        vendorId: null,
        defaultReasonName: null,
      },
      reasonValue: [],
      exemptionReasonValue: [],
      reasonList: [],
      exemptionReasonList: [],
    };
  },
  computed: {
    disabledBatch() {
      const set = new Set();
      this.selection.forEach((item) => {
        if (!item.causeRecordId) {
          set.add(item.orderBreakTypeId);
        }
      });
      const arr = [...set];
      return arr.length !== 1;
    },
  },
  mounted() {
    getDefaultReasonList().then(res => {
      this.reasonList = (res.data.data || []).map(item => {
        return {
          label: item.defaultReasonName,
          value: item.defaultReasonId,
          children: item.childrenList.map(item2 => {
            return {
              label: item2.defaultReasonName,
              value: item2.defaultReasonId,
            }
          })
        }
      })
    })
    getExemptionReasonList().then(res => {
      this.exemptionReasonList = (res.data.data || []).map(item => {
        return {
          label: item.exemptionReasonName,
          value: item.exemptionReasonId,
          children: item.childrenList.map(item2 => {
            return {
              label: item2.exemptionReasonName,
              value: item2.exemptionReasonId,
            }
          })
        }
      })
    })
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      const params = {
        vendorId: this.vendorId,
        startAt: this.startAt,
        endAt: this.endAt,
        breakCodes: this.query ? this.queryForm.breakCodes : this.breakCodes,
        breakDay: this.query ? null : this.breakDay,
        recordType: this.queryForm.recordType,
        orderLineNum: this.queryForm.orderLineNum,
        currentPage: this.queryForm.pageNo,
        pageSize: this.queryForm.pageSize,
      }
      if (this.query) {
        params.breakCodes = this.queryForm.breakCodes;
      }
      getPerformanceOrderList(params).then((res) => {
        this.tableData = res.data.data && res.data.data.list || [];
        this.total = res.data.data.total;
        this.loading = false;
      });
    },
    init() {
      this.getTableData();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    handleChangeReason(res) {
      this.form.defaultReasonId = res[1];
    },
    handleChangeExemptionReason(res) {
      this.form.exemptionReasonId = res[1];
    },
    showBatchForm() {
      this.submitRepeat = false;
      const orderLineNum = this.selection.map((item) => {
        return item.orderLineNum;
      });
      this.showOrderLineNum = orderLineNum.join("、");
      this.showBreakType = this.selection[0].breakType;
      this.form.causeRecordId = this.selection[0].causeRecordId;
      this.form.defaultReasonId = this.selection[0].defaultReasonId;
      this.form.defaultRemark = this.selection[0].defaultRemark;
      this.form.exemptionDetailId = this.selection[0].exemptionDetailId;
      this.form.exemptionFlag = this.selection[0].exemptionFlag == 2 ? true : false;
      this.form.exemptionReasonId = this.selection[0].exemptionReasonId;
      this.form.exemptionRemark = this.selection[0].exemptionRemark;
      this.form.orderBreakTypeId = this.selection[0].orderBreakTypeId;
      this.form.itemReqs = this.selection.map((item) => {
        return {
          idLogisticsProductBreak: item.idLogisticsProductBreak,
          orderLineNum: item.orderLineNum,
        };
      });
      this.reasonValue = [];
      this.exemptionReasonValue = [];
      this.formType = 2;
      this.dialogVisible = true;
    },
    showForm(row, type) {
      this.submitRepeat = false;
      this.showOrderLineNum = row.orderLineNum;
      this.showBreakType = row.breakType;
      this.form.causeRecordId = row.causeRecordId;
      this.form.defaultReasonId = row.defaultReasonId;
      this.form.defaultRemark = row.defaultRemark;
      this.form.exemptionDetailId = row.exemptionDetailId;
      this.form.exemptionFlag = row.exemptionFlag == 2 ? true : false;
      this.form.exemptionReasonId = row.exemptionReasonId;
      this.form.exemptionRemark = row.exemptionRemark;
      this.form.itemReqs = [{
        idLogisticsProductBreak: row.idLogisticsProductBreak,
        orderLineNum: row.orderLineNum,
      }];
      this.form.orderBreakTypeId = row.orderBreakTypeId;
      this.form.orderLineNum = row.orderLineNum;
      this.formType = type;
      if (type === 1) {
        this.setCascaderValue();
      } else {
        this.reasonValue = [];
        this.exemptionReasonValue = [];
      }
      this.dialogVisible = true;
    },
    setCascaderValue() {
      if (this.form.defaultReasonId) {
        this.reasonList.some(item => {
          return item.children.some(item2 => {
            if (item2.value === this.form.defaultReasonId) {
              this.reasonValue = [item.value, item2.value];
              return true;
            }
            return false;
          })
        })
      }
      if (this.form.exemptionReasonId) {
        this.exemptionReasonList.some(item => {
          return item.children.some(item2 => {
            if (item2.value === this.form.exemptionReasonId) {
              this.exemptionReasonValue = [item.value, item2.value];
              return true;
            }
            return false;
          })
        })
      }
    },
    getCascaderLabel() {
      this.form.defaultReasonName = '';
      if (this.form.defaultReasonId) {
        this.reasonList.some(item => {
          return item.children.some(item2 => {
            if (item2.value === this.form.defaultReasonId) {
              this.form.defaultReasonName = `${item.label}/${item2.label}`;
              return true;
            }
            return false;
          })
        })
      }
      this.form.exemptionReasonName = '';
      if (this.form.exemptionReasonId) {
        this.exemptionReasonList.some(item => {
          return item.children.some(item2 => {
            if (item2.value === this.form.exemptionReasonId) {
              this.form.exemptionReasonName = `${item.label}/${item2.label}`;
              return true;
            }
            return false;
          })
        })
      }
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    submitForm() {
      if (this.submitRepeat) {
        return;
      }
      this.submitRepeat = true;
      this.$refs.form.validate(valid => {
        if (valid) {
          this.getCascaderLabel();
          const params = {
            causeRecordId: this.form.causeRecordId,
            defaultReasonId: this.form.defaultReasonId,
            defaultRemark: this.form.defaultRemark,
            exemptionDetailId: this.form.exemptionDetailId,
            exemptionFlag: this.form.exemptionFlag ? 2 : 1,
            orderLineNum: this.form.orderLineNum,
            vendorId: this.vendorId,
            defaultReasonName: this.form.defaultReasonName,
            exemptionReasonName: this.form.exemptionReasonName,
          };
          let request = editExemption;
          if (this.formType == 2) {
            params.itemReqs = this.form.itemReqs;
            params.orderBreakTypeId = this.form.orderBreakTypeId;
            request = batchSaveExemption;
          }
          if (this.form.exemptionFlag) {
            params.exemptionReasonId = this.form.exemptionReasonId;
            params.exemptionRemark = this.form.exemptionRemark;
          }
          request(params).then(res => {
            if (res.data.data) {
              this.$message.success('提交成功');
              this.dialogVisible = false;
              this.getTableData();
            } else {
              this.$message.error(res.data.message);
            }
          }).catch(() => {
            this.submitRepeat = false;
          })
        } else {
          this.submitRepeat = false;
        }
      })
    },
  },
};
</script>

<style lang="less" scoped>
.ml10 {
  margin-left: 10px;
}
.inline-block {
  display: inline-block;
  vertical-align: middle;
}
.pagination {
  margin-top: 10px;
  text-align: right;
}
.tag {
  display: inline-block;
  padding: 0 5px;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  border: 1px solid #dcdfe6;
  border-radius: 5px;

  &.success {
    color: #fff;
    background-color: #67c23a;
    border-color: #67c23a;
  }
  &.primary {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
  }
}
</style>
